<template>
  <div>
    <v-overlay :value="isLoading"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    <!-- MENU CONTAINER SECTION BACKGROUND -->
    <div class="menu_container_section_background">
      <div class="col-md-12 menu_container_section_container" v-if="!showPublicidade">
        <div v-for="(menu, index) in itensMenuHome" :key="index" class="menu_container_section_"
          @click="handleClick(menu)">
          <div v-if="menu.novo == 1" class="novo-badge-item-menu">Novo</div>
          <figure class="menu_container_section_img">
            <img :src="menu.icon" />
          </figure>
          <div class="menu_container_section_text_container">
            <span class="menu_container_section_text_title">{{ menu.descricao }}</span>
          </div>
        </div>
      </div>
       <div class="col-md-12" v-if="showPublicidade">
          <div v-html="anuncioHtml"></div>

           <div style="text-align: center;">
            <div class="v-card pa-6 d-flex flex-column align-center justify-center elevation-12 anuncio-card-elegante"
  style="background-color: #fff8e1; mborder: 2px solid #fff8e1; border-radius: 0px 0px 16px 16px; max-width: 1200px; margin:-18px auto;">
   <div
  class="v-btn mt-4 white--text font-weight-bold px-6"
  style="
    background-color: #00C3E3;
    color: white;
    border-radius: 24px;
    padding: 10px 28px;
    text-align: center;
    font-weight: 700;
    cursor: pointer;
    display: inline-block;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    user-select: none;
    transition: background-color 0.3s ease;
  "
  @click="fecharAnuncio()"
 >
  Fechar e Continuar
</div>
            </div>
</div>

      </div>

    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
import ItensMenuUtilitarios from '@/utilitarios/ItensMenuUtilitarios';
export default {
  data: () => ({
    itensMenuHome: [],
    isLoading: false,
    dialogoDocumentos: false,
    publicidade:[],
    anuncioHtml: null,
    idInstituicao: ls.get('i_id'),
    documentosSolicitados: [],
    anuncio:ls.get('anuncio'),
    inc: 1,
    alert: true,
    dialog: false,
    items: [],
    ordemMesesPagamento: [
      { mes: 'Janeiro', status: 'N/PAGO' },
      { mes: 'Fevereiro', status: 'N/PAGO' },
      { mes: 'Março', status: 'N/PAGO' },
      { mes: 'Abril', status: 'N/PAGO' },
      { mes: 'Maio', status: 'N/PAGO' },
      { mes: 'Junho', status: 'N/PAGO' },
      { mes: 'Julho', status: 'N/PAGO' },
      { mes: 'Agosto', status: 'N/PAGO' },
      { mes: 'Setembro', status: 'N/PAGO' },
      { mes: 'Outubro', status: 'N/PAGO' },
      { mes: 'Novembro', status: 'N/PAGO' },
      { mes: 'Dezembro', status: 'N/PAGO' },
    ],
    overlay: false,
    objecto: null,
    funcionario: null,
    data_logged: null,
    diasCounter: null,
    path: '',
    showPub: ls.get('showPublicity')
  }),
  async created() {
    this.$store.state.idclasse = null
    this.itensMenuHome = await ItensMenuUtilitarios.getItensByMenu(1);
    this.ObterMensalidadeQuota()
    if (this.isintegrado || ls.get('i_id') === 19) {
      ls.set('rotaTurma', './views/tec-ped/turma/TurmacrudLocal.vue')
      this.actualizaTokenParaOsLocais()
    } else {
      ls.set('rotaTurma', './views/tec-ped/turma/Turmacrud.vue')
      this.actualizaToken()
    }

    // this.InstituicaoProveniente()
    this.getPublicidade()
    this.ObterCursoCoordenador()
    this.ObterAcessosDados()
    this.ActualizarDataLogado_()
    this.carregarConfiguracoesReports()
    this.getConfiguracaoPauta()
   // this.setPath()
  },

  computed: {
    isintegrado() {
      return ls.get('isintegrado')
    },
    islicencaExpirada() {
      return ls.get('licencaExpirada')
    },
    role() {
      return ls.get('role')
    },
    navegador() {
      return navigator.userAgent
    },

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    showPublicidade(){
      return this.anuncio && this.publicity === '1' && !this.isIMS
    },

    isBendizer() {
      return window.location.host.includes('bendizer')
    },

    

    bigText() {
      return "<iframe allowfullscreen='true' width='100%' height=100% src=" + this.path + " title='W3Schools Free Online Web Tutorials'></iframe>"
    },

    publicity() {
      return ls.get('publicity')
    },

    instituicaodescricao() {
      return ls.get('instituicaodescricao')
    },
    anolectivo() {
      return ls.get('anolectivo')
    },

    MostrarPublicidade() {
      return ls.get('closePublicidade')
    },

    isIMS (){
       return ls.get('i_id') === 144 || ls.get('i_id') === 1
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },

    idInstituicao() {
      return ls.get('i_id')
    },

    idPessoa() {
      return ls.get('idPessoa')
    },

    role_() {
      return ls.get('role')
    },

    logged_date_control() {
      return ls.get('logged_date_control')
    }
  },


  methods: {
    fecharDocumentos() {
      this.dialogoDocumentos = false;
    },

    printDocumento(documento) {
      try {
        if (documento.idDocumento == 1) {
          console.log('Boletim, Todos trimestres');
        } else if (documento.idDocumento == 2) {
          console.log('2ª via do certificado');
        } else if (documento.idDocumento == 6) {
          console.log('Boletim (1º trimestre)');
        } else if (documento.idDocumento == 7) {
          console.log('Boletim (2º trimestre)');
        } else if (documento.idDocumento == 8) {
          console.log('Boletim (3º trimestre)');
        } else {
          console.log('Documento não encontrado');
        }
      } catch (error) {
        console.log(error);
      }
    },

    fecharAnuncio  (){
       ls.set('anuncio', false)
       this.anuncio = false        
    },

    handleClick(menu) {
      if (menu.validarLicenca === 1) {
        if (this.islicencaExpirada === 1) {
          Swal.fire(
            'Informação',
            'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!',
            'info'
          );
          return;
        }
      }
      if (menu.isRota === 1) {
        this.$router.push(menu.url);
      } else if (menu.funcao) {
        eval(menu.funcao);
      }
    },

    renderForm() {
      window.open("https://forms.office.com/r/UzTgx4zWiX?origin=lprLink", "_blank");
    },

    setRouter(router) {
      this.$store.state.fromMenu = 'gestao'
      this.$router.push(router)
    },

    IndisponivelMomento() {
      Swal.fire('Informação', 'Funcionalidade indisponível de momento.', 'warning')
    },

    async carregarConfiguracoesReports() {
      try {
        let msg = await axios
          .get('/configuracoesAll')
          .then(res => res.data)
        if (msg.length > 0) {
          ls.set('configuracoesReport', msg)
          ls.set('api', msg.filter(c => c.chave === 'api'))
          let url = msg.filter(c => c.idConfiguracoes === 40)
          ls.set('urlReport', (url.length ? url[0].valor : ''))
          let urlFoto = msg.filter(c => c.idConfiguracoes === 31)
          ls.set('urlFoto', (urlFoto.length ? urlFoto[0].valor : ''))
          let logotipo = msg.filter(c => c.idConfiguracoes === 32)
          ls.set('logotipo', (logotipo.length ? logotipo[0].valor : ''))
          let insignia = msg.filter(c => c.idConfiguracoes === 33)
          ls.set('insignia', (insignia.length ? insignia[0].valor : ''))
          let subdirector = msg.filter(c => c.idConfiguracoes === 41)
          ls.set('subdirector', (subdirector.length ? subdirector[0].valor : ''))
          let nomeInstituicao = msg.filter(c => c.idConfiguracoes === 42)
          ls.set('nomeInstituicao', (nomeInstituicao.length ? nomeInstituicao[0].valor : ''))
          let directora_ims_profissao = msg.filter(c => c.idConfiguracoes === 43)
          ls.set('directora_ims_profissao', (directora_ims_profissao.length ? directora_ims_profissao[0].valor : ''))
          let directora_ims = msg.filter(c => c.idConfiguracoes === 44)
          ls.set('directora_ims', (directora_ims.length ? directora_ims[0].valor : ''))
        }
      } catch (error) {

      }
    },
    //  ******************************************

    setPath() {
      this.overlay = true
      setTimeout(() => {
        this.overlay = false
        this.path = this.publicity
      }, 2000)
    },

    async ObterMensalidadeQuota() {
      try {
        let result = await axios.get('/getInfoPagementoQuotas').then(res => res.data)
        if (result.length) {
          ls.set('statusPago', this.setStatusPago(result, utilitarios.ObterMesActual()));
          ls.set('mesesNaoPago', this.ordemMesesPagamento.filter(f => f.status === 'N/PAGO'))
        }
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar os pagamentos de quota')
      }
    },


   showSugestao(){
    this.$store.dispatch('toggleSugestao', true); // abrir
   },




    setStatusPago(pagamentos, mesActual) {

      let element = pagamentos[0]
      this.ordemMesesPagamento[0].status = element.isPago1
      this.ordemMesesPagamento[1].status = element.isPago2
      this.ordemMesesPagamento[2].status = element.isPago3
      this.ordemMesesPagamento[3].status = element.isPago4
      this.ordemMesesPagamento[4].status = element.isPago5
      this.ordemMesesPagamento[5].status = element.isPago6
      this.ordemMesesPagamento[6].status = element.isPago7
      this.ordemMesesPagamento[7].status = element.isPago8
      this.ordemMesesPagamento[8].status = element.isPago9
      this.ordemMesesPagamento[9].status = element.isPago10
      this.ordemMesesPagamento[10].status = element.isPago1
      this.ordemMesesPagamento[11].status = element.isPago11
      switch (mesActual) {
        case 1:
          {
            this.ordemMesesPagamento[0].status = element.isPago1
            return element.isPago1
          }
        case 2:
          {
            this.ordemMesesPagamento[1].status = element.isPago2
            return element.isPago2
          }
        case 3:
          {
            this.ordemMesesPagamento[2].status = element.isPago3
            return element.isPago3
          }
        case 4:
          {
            this.ordemMesesPagamento[3].status = element.isPago4
            return element.isPago4
          }
        case 5:
          {
            this.ordemMesesPagamento[4].status = element.isPago5
            return element.isPago5
          }
        case 6:
          {
            this.ordemMesesPagamento[5].status = element.isPago6
            return element.isPago6
          }
        case 7:
          {
            this.ordemMesesPagamento[6].status = element.isPago7
            return element.isPago7
          }
        case 8:
          {
            this.ordemMesesPagamento[7].status = element.isPago8
            return element.isPago8
          }
        case 9:
          {
            this.ordemMesesPagamento[8].status = element.isPago9
            return element.isPago9
          }
        case 10:
          {
            this.ordemMesesPagamento[9].status = element.isPago10
            return element.isPago10
          }
        case 11:
          {
            this.ordemMesesPagamento[10].status = element.isPago11
            return element.isPago11
          }
        case 12:
          {
            this.ordemMesesPagamento[11].status = element.isPago12
            return element.isPago12
          }

        default:
          return 'Inválido'
      }

    },

    async actualizaToken() {
      try {
        let url = (this.isintegrado) ? "/actualizaTokenParaOSIntegrados" : "/actualizaToken"
        // eslint-disable-next-line no-unused-vars
        let result = await axios
          .post(url)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }
    },


    async actualizaTokenParaOsLocais() {
      try {
        let usuario = await axios({
          method: 'post',
          url: 'https://restrito.softlineangola.com/api/actualizaTokenParaLocais',
          data: { token: ls.get('token'), username: ls.get('username') }
        }).then(res => res.data)
        this.overlay = false

      } catch (error) {

      } finally {
        this.overlay = false
      }

    },

    async InstituicaoProveniente() {
      try {
        this.overlay = true
        this.funcionario = await axios
          .post('/ObterInstituicaoProveniencia', { idPessoa: this.idPessoa })
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }
    },


     async getPublicidade() {
      try {
        this.overlay = true
        this.publicidade = await axios
          .get('/obterPublicidade',)
          .then(res => res.data)
        this.overlay = false
        if( this.publicidade.length ){
          this.anuncioHtml = this.publicidade[0].html.replace('{{ instituicaodescricao }}', this.instituicaodescricao);
        }
        
      } catch (error) {
        this.overlay = false
      }
    },

    async ActualizarDataLogado_() {
      this.data_logged = ls.get('logged_date_control')
      this.diasCounter = utilitarios.NumberOfDayLeft(this.data_logged, utilitarios.ObterDataActual())
    },

    MostrarDialogo(item) {
      this.objecto = item
      this.dialog = true
    },

    avaliarSistema() {
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" src="https://docs.google.com/forms/d/e/1FAIpQLSfoMX9rkI7ylx8kYy98yIw2t_V5cnSExd2Awto5fP3_sm4V3w/viewform?usp=sf_link"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },

    MudarSenhaPerfil() {
      this.$router.push('perfil')
      this.$store.state.tabPerfil = 1
    },

    async GetUserLocation() {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(longitude, latitude)
        })
    },

    closePublicity() {
      this.overlay = true
      setTimeout(() => {
        ls.set('showPublicity', false)
        this.path = ''
        this.showPub = false
        this.overlay = false
      }, 1000)
    },

    async ObterDataTimeRemote() {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero(data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async getConfiguracaoPauta() {
      try {
        const response = await axios.get('/configuracao-pauta/buscar/' + this.idInstituicao)
        const filteredData = response.data.map(item => ({
          idConfiguracao: item.idConfiguracao,
          idInstituicao: item.idInstituicao,
          titulo: item.titulo,
          chave: item.chave,
          valor: item.valor
        }))
        ls.set('configuracaoPauta', filteredData)
      } catch (error) {
        console.error(error)
      }
    },

    async ObterCursoCoordenador() {
      if (this.role_ === 'ROLE_COOR') {
        try {
          // eslint-disable-next-line no-unused-vars
          let result = await axios
            .post('/obterCursoCoordenador')
            .then(res => res.data)
          if (result.length) {
            ls.set('idCursoCoordenador', result[0].idCurso)
          }
        } catch (error) {

        }
      }
      this.overlay = false
    },

    async MudarInstuicaoNovo() {
      this.dialog = false

      // this.editedItem=item
      const ls = require('local-storage')

      var params = {
        id: this.funcionario[0].idinstituicao,
        descricao: (this.funcionario[0].idinstituicao === 5) ? 'Softline' : 'EFTSLuanda'
      }

      try {
        let msg = await axios
          .post('/mudarInstituicao', params)
          .then(res => res.data)
        ls.set('i_id', this.funcionario[0].idinstituicao)
        // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
          // this.Controlo_actividade()
        } catch (error) { }
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        setTimeout(() => {
          this.logout()
        }, 1000)
      }
    },

    logout() {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async ObterAcessosDados() {
      if (ls.get('role') === 'ROLE_PED') {
        try {
          // eslint-disable-next-line no-unused-vars
          this.items = await axios
            .get('/listarAcessoDados')
            .then(res => res.data)
        } catch (error) {

        }
      }
    },

    async Continuar() {
      this.dialog = false
      this.overlay = true
      const params =
      {
        item: this.objecto
      }
      try {
        // eslint-disable-next-line no-unused-vars
        let msg = await axios
          .post('/removerAcessoInstituicao', params)
          .then(res => res.data)
        if (msg.affectedRows >= 0) {
          this.$store.dispatch('textMessage', {
            msg: 'Acesso removido com sucesso',
            classMessage: 'msgSucess',
            timeout: 4000
          })
        }
        this.ObterAcessosDados()
        this.overlay = false
      } catch (error) {

      }
    },

    showServicos() {
      this.$router.push('mais-servicos')
    }

  }

}
</script>
<style scoped>
.anuncio-card-elegante {
  border-radius: 16px;
  background: #f1f8e9; /* tom suave de verde claro */
  transition: all 0.3s ease-in-out;
}

.anuncio-card-elegante:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}
</style>
